import ActivitySlider from "./components/ActivitySlider.vue";
import ArticleSlider from "./components/ArticleSlider.vue";
import BannerSlider from "./components/BannerSlider.vue";
import CardWrapper from "./components/CardWrapper.vue";
import FooterSep from "./components/FooterSep.vue";
import MemberTab from "./components/MemberTab.vue";
import PasswordEye from "./components/PasswordEye.vue";
import UniaiAiMessage from "./components/UniaiAiMessage.vue";
import UniaiBreadcrumbs from "./components/UniaiBreadcrumbs.vue";
import UniaiButton from "./components/UniaiButton.vue";
import UniaiCheckbox from "./components/UniaiCheckbox.vue";
import UniaiCheckboxButton from "./components/UniaiCheckboxButton.vue";
import UniaiClientMessage from "./components/UniaiClientMessage.vue";
import UniaiDialog from "./components/UniaiDialog.vue";
import UniaiField from "./components/UniaiField.vue";
import UniaiFieldGroup from "./components/UniaiFieldGroup.vue";
import UniaiForm from "./components/UniaiForm.vue";
import UniaiInput from "./components/UniaiInput.vue";
import UniaiLogo from "./components/UniaiLogo.vue";
import UniaiPager from "./components/UniaiPager.vue";
import UniaiRadioButton from "./components/UniaiRadioButton.vue";
import UniaiSelect from "./components/UniaiSelect.vue";
import UniaiTextarea from "./components/UniaiTextarea.vue";
import UniaiToast from "./components/UniaiToast.vue";

const components = {
    ActivitySlider,
    ArticleSlider,
    BannerSlider,
    CardWrapper,
    FooterSep,
    MemberTab,
    PasswordEye,
    UniaiAiMessage,
    UniaiBreadcrumbs,
    UniaiButton,
    UniaiCheckbox,
    UniaiCheckboxButton,
    UniaiClientMessage,
    UniaiDialog,
    UniaiField,
    UniaiFieldGroup,
    UniaiForm,
    UniaiInput,
    UniaiLogo,
    UniaiPager,
    UniaiRadioButton,
    UniaiSelect,
    UniaiTextarea,
    UniaiToast
};

export default {
    install: (app) => {
        for (const name in components) {
            app.component(name, components[name]);
        }
    }
};
